/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.reviews.rpc.ReviewsRpc
 */

/**
 *  This class can be used as a response type in cases where no response is needed or
 *  where <code>void</code> might have been used in a REST-ful context.
 */

/**
 * Virtual record for map with known enum keys
 */

/**
 * Virtual record for map with known enum keys
 */

/**
 *  A review's private feedback: only the answers and ratings marked private in the schema, not the
 *  review's full public content.
 */

export let ComHubspotReviewsModelsAbstractGenerateTitleError;
(function (_ComHubspotReviewsModelsAbstractGenerateTitleError) {})(ComHubspotReviewsModelsAbstractGenerateTitleError || (ComHubspotReviewsModelsAbstractGenerateTitleError = {}));
export let ComHubspotReviewsModelsAbstractGetPrivateFeedbackError;
(function (_ComHubspotReviewsModelsAbstractGetPrivateFeedbackError) {})(ComHubspotReviewsModelsAbstractGetPrivateFeedbackError || (ComHubspotReviewsModelsAbstractGetPrivateFeedbackError = {}));
export let ComHubspotReviewsModelsAbstractGetSummaryError;
(function (_ComHubspotReviewsModelsAbstractGetSummaryError) {})(ComHubspotReviewsModelsAbstractGetSummaryError || (ComHubspotReviewsModelsAbstractGetSummaryError = {}));
export let ComHubspotReviewsModelsAbstractReviewMutationError;
(function (_ComHubspotReviewsModelsAbstractReviewMutationError) {})(ComHubspotReviewsModelsAbstractReviewMutationError || (ComHubspotReviewsModelsAbstractReviewMutationError = {}));
export let ComHubspotReviewsModelsAbstractReviewTypeError;
(function (_ComHubspotReviewsModelsAbstractReviewTypeError) {})(ComHubspotReviewsModelsAbstractReviewTypeError || (ComHubspotReviewsModelsAbstractReviewTypeError = {}));
export let ComHubspotReviewsModelsAbstractReviewabilityError;
(function (_ComHubspotReviewsModelsAbstractReviewabilityError) {})(ComHubspotReviewsModelsAbstractReviewabilityError || (ComHubspotReviewsModelsAbstractReviewabilityError = {}));
export let ComHubspotReviewsModelsAbstractSearchReviewsError;
(function (_ComHubspotReviewsModelsAbstractSearchReviewsError) {})(ComHubspotReviewsModelsAbstractSearchReviewsError || (ComHubspotReviewsModelsAbstractSearchReviewsError = {}));
export let ComHubspotReviewsModelsNotificationsAbstractPreviewReviewRequestEmailError;
(function (_ComHubspotReviewsModelsNotificationsAbstractPreviewReviewRequestEmailError) {})(ComHubspotReviewsModelsNotificationsAbstractPreviewReviewRequestEmailError || (ComHubspotReviewsModelsNotificationsAbstractPreviewReviewRequestEmailError = {}));
export let ComHubspotReviewsModelsThemesAbstractGetThemesError;
(function (_ComHubspotReviewsModelsThemesAbstractGetThemesError) {})(ComHubspotReviewsModelsThemesAbstractGetThemesError || (ComHubspotReviewsModelsThemesAbstractGetThemesError = {}));
export const generateTitleRpc = {
  serviceName: 'com.hubspot.reviews.rpc.ReviewsRpc',
  rpcName: 'generateTitle',
  auth: 'app',
  fingerprint: 'fqdMoQlzJDzmxBCl8KDHlJG0DHPqwZAw',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getSummaryRpc = {
  serviceName: 'com.hubspot.reviews.rpc.ReviewsRpc',
  rpcName: 'getSummary',
  auth: 'app',
  fingerprint: 'w4ShM0OOxZaic1v6FGKGHm5znO6Jte-P',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getEditabilityRpc = {
  serviceName: 'com.hubspot.reviews.rpc.ReviewsRpc',
  rpcName: 'getEditability',
  auth: 'app',
  fingerprint: 'aTRGwrPgigzdtK6GeSw-g-dNEFbj_dt7',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getThemesRpc = {
  serviceName: 'com.hubspot.reviews.rpc.ReviewsRpc',
  rpcName: 'getThemes',
  auth: 'app',
  fingerprint: 'fMDThFkFbqwnKDiSpQZsP-C6RBaWvYMU',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const searchReviewsRpc = {
  serviceName: 'com.hubspot.reviews.rpc.ReviewsRpc',
  rpcName: 'searchReviews',
  auth: 'app',
  fingerprint: '2zDvX7GKho9m3yklrJcXf-C7Y-r6etvU',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const searchReviewsLegacyRpc = {
  serviceName: 'com.hubspot.reviews.rpc.ReviewsRpc',
  rpcName: 'searchReviewsLegacy',
  auth: 'app',
  fingerprint: '2zDvX7GKho_j9yFWkyrTmOC7Y-r6etvU',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const checkReviewabilityRpc = {
  serviceName: 'com.hubspot.reviews.rpc.ReviewsRpc',
  rpcName: 'checkReviewability',
  auth: 'app',
  fingerprint: 'rK6Gz27x3T-OUe2e_r4XmdPzNCIu_Fnt',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const checkReviewabilityByAppIdsRpc = {
  serviceName: 'com.hubspot.reviews.rpc.ReviewsRpc',
  rpcName: 'checkReviewabilityByAppIds',
  auth: 'app',
  fingerprint: 'BsWryMa_oaZYRK7MDLUPdtPzNCIu_Fnt',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getOverallStatsRpc = {
  serviceName: 'com.hubspot.reviews.rpc.ReviewsRpc',
  rpcName: 'getOverallStats',
  auth: 'app',
  fingerprint: 'Cd1r4NjxaRsq_MWw2l3YQbO_C9QUba5Y',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getOverallStatsBatchRpc = {
  serviceName: 'com.hubspot.reviews.rpc.ReviewsRpc',
  rpcName: 'getOverallStatsBatch',
  auth: 'app',
  fingerprint: 'V-Y68wXlE-cEZ_3SCaD797O_C9QUba5Y',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getReviewStatsRpc = {
  serviceName: 'com.hubspot.reviews.rpc.ReviewsRpc',
  rpcName: 'getReviewStats',
  auth: 'app',
  fingerprint: '7LR9ynyuLvIfECQPffDsSrO_C9QUba5Y',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getReviewStatsBatchRpc = {
  serviceName: 'com.hubspot.reviews.rpc.ReviewsRpc',
  rpcName: 'getReviewStatsBatch',
  auth: 'app',
  fingerprint: 'cGiw2jBhtoUCzEvvvSk1KbO_C9QUba5Y',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getPrivateFeedbackRpc = {
  serviceName: 'com.hubspot.reviews.rpc.ReviewsRpc',
  rpcName: 'getPrivateFeedback',
  auth: 'app',
  fingerprint: 'cBpM1fNtfbVb1GUijSNljrF3tT30u0iZ',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getReviewRequestEmailTokensRpc = {
  serviceName: 'com.hubspot.reviews.rpc.ReviewsRpc',
  rpcName: 'getReviewRequestEmailTokens',
  auth: 'app',
  fingerprint: 'AAAAAAAAAACINleg96NDbZwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const previewReviewRequestEmailRpc = {
  serviceName: 'com.hubspot.reviews.rpc.ReviewsRpc',
  rpcName: 'previewReviewRequestEmail',
  auth: 'app',
  fingerprint: 'FDxdRcQ_jaCMsJmj-C-KVfPdMdEVFeQc',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getReviewTagsRpc = {
  serviceName: 'com.hubspot.reviews.rpc.ReviewsRpc',
  rpcName: 'getReviewTags',
  auth: 'app',
  fingerprint: 'AAAAAAAAAABx42BfnpCCI5wP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getReviewerDisplayNameRpc = {
  serviceName: 'com.hubspot.reviews.rpc.ReviewsRpc',
  rpcName: 'getReviewerDisplayName',
  auth: 'app',
  fingerprint: 'AAAAAAAAAACqMt9eT6GjPedNEFbj_dt7',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getOwnReviewsByAppIdsRpc = {
  serviceName: 'com.hubspot.reviews.rpc.ReviewsRpc',
  rpcName: 'getOwnReviewsByAppIds',
  auth: 'app',
  fingerprint: 'A3IiYp_GBBsMeM23VjrYtedNEFbj_dt7',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};